export default __webpack_public_path__ + "static/media/ConveyorPole_Wall.256.f96a35a6.png";